<template>
    <div class="page box has-background-white-biys  has-text-dark">
        <div class="tabs pt-5" id="tabs">
            <ul>
                <li :class="[curr_tab == 'liste' ? 'is-active' : '']">
                    <router-link to="/equipesmobiles/liste">Les EMPSA en IdF</router-link>
                </li>
                <li :class="[curr_tab == 'rechercher' ? 'is-active' : '']">
                    <router-link to="/equipesmobiles/rechercher">Chercher une EMPSA</router-link>
                </li>
                <li :class="[curr_tab == 'fiche' ? 'is-active' : '']">
                    <router-link :to="'/equipesmobiles/fiche/'+curr_equipe">Présentation des équipes</router-link>
                </li>
            </ul>
        </div>
        <div v-if="loading" class="loading">
            Loading...
        </div>
        <div v-if="error" class="notification is-light">
            <NotFound />
        </div>
        <div v-if="curr_tab == 'liste'" class="content px-5 py-5">
            <div v-if="equipes">
                <p>Les équipes mobiles de Psychiatrie du sujet âgé se développent en Ile-de-France depuis quelques années afin de répondre à la difficulté d’accès aux soins, liée au manque de mobilité des personnes, à leur isolement, leur fragilité et au risque de situations de rupture.<br><br>
Le maintien au domicile étant un enjeu de santé publique, il est nécessaire « d’aller vers » pour mieux coordonner le parcours de soins de la personne.
<br><br>Les missions des EMPSA s’articulent autour de 3 principaux axes : évaluer, orienter et coordonner.
<br><br>Les équipes mobiles ont aussi un rôle d’acculturation au soin psychique et de formation des équipes avec lesquelles elles collaborent dans le champ de la psychiatrie du sujet âgé.</p>
                <h4 class="title is-5 pt-4">Répartition en IDF</h4>
                <figure class="image is-4by3">
                    <iframe class="has-ratio" width="100%" height="300px" frameborder="0" allowfullscreen src="//umap.openstreetmap.fr/fr/map/equipes-mobiles_627383?scaleControl=false&miniMap=false&scrollWheelZoom=true&zoomControl=true&allowEdit=false&moreControl=true&searchControl=null&tilelayersControl=null&embedControl=null&datalayersControl=true&onLoadPanel=undefined&captionBar=false"></iframe>
                </figure>
                <h4 class="title is-5 pt-2 is-hidden">Liste des équipes mobiles</h4>
                <div class="table-container">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Equipe</th>
                                <th>Hôpital de rattachement</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="equipe in equipes" v-bind:key="equipe._id">
                                <td>{{equipe.title}}
                                    <span class="tag is-warning is-hidden" v-for="se in equipe.secteur" v-bind:key="se._id">{{se}}</span>
                                </td>
                                <td><span v-if="equipe.hopitalrattachement">{{equipe.hopitalrattachement.toUpperCase()}}</span></td>
                                <td>
                    <b-button tag="router-link" :to="'/' + equipe.slug + '#tabs'" type="is-primary" size="is-small" outlinedx rounded>
                                        + infos
                                    </b-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-if="curr_tab == 'rechercher'" class="content px-5 py-5">
            <h4 class="title is-5">Chercher une EMPSA</h4>
            <p class="pt-2">Entrer le nom d'une ville ou un code postal :</p>
            <div class="has-text-centered">
                <form @submit.prevent="searchEM2">
                    <b-field>
                        <b-input placeholder="Chercher..." type="search" icon="magnify" size="is-medium" v-model="searchQuery" expanded>
                        </b-input>
                        <p class="control">
                            <b-button native-type="submit" type="is-primary" label="Valider" size="is-medium" />
                        </p>
                    </b-field>
                </form>
            </div>
            <p class="notification" v-if="searchInit">
                <template v-if="!!searchResult">Equipe(s) trouvée(s) :<br><br>
                    <div class="has-text-left py-1 mb-5 bloc_equipe" v-for="matchItem in searchResultEquipes" v-bind:key="matchItem.equipe._id">
                        <div>
                            {{matchItem.equipe.title}}<span v-if="matchItem.equipe.hopitalrattachement"> (rattachement : {{matchItem.equipe.hopitalrattachement.toUpperCase()}})</span>
                            <b-button tag="router-link" :to="'/' + matchItem.equipe.slug" type="is-primary" size="is-small" class="mx-4" rounded>+ infos</b-button>
                        </div>
                        <div class="search-match-list" v-if="matchItem.matchedTerms && matchItem.matchedTerms.length">
                            <span class="search-match-label ml-4">Terme(s) trouvé(s) :</span>
                            <span class="search-match" v-for="(term, idx) in matchItem.matchedTerms" :key="idx" :class="term.type">{{ term.raw }}</span>
                        </div>
                    </div>
                    <p class="notification pt-6 is-italic" v-if="searchResultMult"><b>Attention :</b> votre recherche a donné plusieurs résultats. Pour une recherche plus précise, veuillez entrer un code postal.</p>
                </template>
                <template v-else>Il n’y a pas d'EMPSA intervenant sur cette commune</template>
            </p>
        </div>
        <div v-if="curr_equipe !== 'null' && curr_tab == 'fiche'" class="content px-5 py-5">
            <div v-for="equipe in equipes" v-bind:key="equipe._id">
                <div v-if="equipe.slug == 'equipesmobiles/fiche/'+curr_equipe">
                    <h4>{{equipe.title}}</h4>
                    <div v-html="equipe.content"></div>
                </div>
            </div>
        </div>
        <div v-if="curr_equipe == 'null' && curr_tab == 'fiche'" class="content px-5 py-5">
            <i>Veuillez choisir une équipe dans les onglets précédents</i>
        </div>
    </div>
</template>
<script>
const axios = require('axios');
import NotFound from './NotFound.vue'

const SEARCH_MIN_CHARS = 3
const FUZZY_MAX_DISTANCE_SHORT = 1
const FUZZY_MAX_DISTANCE_LONG = 2

function sansAccent(str){
    var accent = [
        /[\300-\306]/g, /[\340-\346]/g, // A, a
        /[\310-\313]/g, /[\350-\353]/g, // E, e
        /[\314-\317]/g, /[\354-\357]/g, // I, i
        /[\322-\330]/g, /[\362-\370]/g, // O, o
        /[\331-\334]/g, /[\371-\374]/g, // U, u
        /[\321]/g, /[\361]/g, // N, n
        /[\307]/g, /[\347]/g, // C, c
    ];
    var noaccent = ['A','a','E','e','I','i','O','o','U','u','N','n','C','c'];

    //str = this;
    for(var i = 0; i < accent.length; i++){
        str = str.replace(accent[i], noaccent[i]);
    }

    return str;
}

function normalizeText(value) {
    var text = String(value || '')
    text = sansAccent(text)
    text = text.toLowerCase()
    text = text.replace(/[-\r\n\t]+/g, ' ')
    text = text.replace(/[^a-z0-9 ]+/g, ' ')
    text = text.replace(/\s+/g, ' ').trim()
    return text
}

function flattenSecteur(secteur) {
    if (Array.isArray(secteur)) {
        return secteur.map(function(item) {
            if (item == null) {
                return ''
            }
            if (typeof item === 'object') {
                return item.title || item.label || item.value || JSON.stringify(item)
            }
            return String(item)
        }).join(' ')
    }
    return String(secteur || '')
}

function levenshteinDistance(a, b) {
    var alen = a.length
    var blen = b.length
    if (alen === 0) return blen
    if (blen === 0) return alen

    var matrix = []
    for (let ii = 0; ii <= blen; ii++) {
        matrix[ii] = [ii]
    }
    for (let jj = 0; jj <= alen; jj++) {
        matrix[0][jj] = jj
    }

    for (let ii = 1; ii <= blen; ii++) {
        for (let jj = 1; jj <= alen; jj++) {
            var cost = a[jj - 1] === b[ii - 1] ? 0 : 1
            matrix[ii][jj] = Math.min(
                matrix[ii - 1][jj] + 1,
                matrix[ii][jj - 1] + 1,
                matrix[ii - 1][jj - 1] + cost
            )
        }
    }

    return matrix[blen][alen]
}

function splitTokens(text) {
    if (!text) {
        return []
    }
    return String(text).split(/(?:\s+[–—-]\s+|[\n,;()]+)/).map(function(chunk) {
        var raw = String(chunk || '').trim()
        if (!raw) {
            return null
        }
        return {
            raw: raw,
            norm: normalizeText(raw)
        }
    }).filter(function(token) {
        return token && token.norm.length > 0
    })
}

function isAdjacentTransposition(query, token) {
    if (!query || !token || query.length !== token.length) {
        return false
    }
    var len = query.length
    var i = 0
    while (i < len && query[i] === token[i]) {
        i++
    }
    if (i >= len - 1) {
        return false
    }
    if (query[i] === token[i + 1] && query[i + 1] === token[i] && query.slice(i + 2) === token.slice(i + 2)) {
        return i < 3
    }
    return false
}

function computeMatchInfo(query, token, maxDistanceShort, maxDistanceLong) {
    if (!query || !token) {
        return { score: 0, type: null }
    }
    if (/^\d+$/.test(token)) {
        if (query === token) {
            return { score: 100, type: 'exact' }
        }
        if (token.startsWith(query)) {
            return { score: 80 - Math.max(0, token.length - query.length), type: 'exact' }
        }
        return { score: 0, type: null }
    }
    if (token === query) {
        return { score: 100, type: 'exact' }
    }
    if (token.startsWith(query)) {
        return { score: 95, type: 'exact' }
    }
    if (query.startsWith(token) && token.length >= 2) {
        return { score: 90, type: 'exact' }
    }
    if (token.includes(query)) {
        return { score: 80, type: 'exact' }
    }
    if (isAdjacentTransposition(query, token)) {
        return { score: 85, type: 'fuzzy' }
    }
    if (query[0] !== token[0] || query.slice(-1) !== token.slice(-1)) {
        return { score: 0, type: null }
    }
    var distance = levenshteinDistance(query, token)
    if (query.length <= 5) {
        if (distance > maxDistanceShort) {
            return { score: 0, type: null }
        }
        return { score: Math.max(1, 75 - distance * 10 + (token.length === query.length ? 5 : 0)), type: 'fuzzy' }
    }
    if (distance > maxDistanceLong) {
        return { score: 0, type: null }
    }
    return { score: Math.max(1, 65 - distance * 10 + (token.length === query.length ? 5 : 0)), type: 'fuzzy' }
}

function computeMatchInfoFromMultiWordToken(query, normToken, maxDistanceShort, maxDistanceLong) {
    var info = computeMatchInfo(query, normToken, maxDistanceShort, maxDistanceLong)
    if (info.score > 0) {
        return info
    }
    var words = normToken.split(' ').filter(function(part) {
        return part.length > 0
    })
    var best = { score: 0, type: null }
    for (var k = 0; k < words.length; k++) {
        var partInfo = computeMatchInfo(query, words[k], maxDistanceShort, maxDistanceLong)
        if (partInfo.score > best.score) {
            best = partInfo
        }
    }
    return best
}

export default {
    data: function() {
        return {
            loading: true,
            error: null,
            curr_tab: null,
            curr_equipe: null,
            maintitle: 'Equipes Mobiles',
            equipes: null,
            searchQuery: null,
            searchResult: false,
            searchResultMult: false,
            searchInit: false,
            searchResultEquipes: [],
            geodata: null,
            searchMinChars: SEARCH_MIN_CHARS,
            fuzzyMaxDistanceShort: FUZZY_MAX_DISTANCE_SHORT,
            fuzzyMaxDistanceLong: FUZZY_MAX_DISTANCE_LONG
        }
    },
    name: 'EquipesMobiles',
    components: {
        NotFound
    },

    created() {
        this.fetchData()
        this.curr_tab = this.$route.params.tab ?? 'liste'
        this.curr_equipe = this.$route.params.equipe ?? this.curr_equipe
    },
    updated() {
        this.curr_tab = this.$route.params.tab ?? 'liste'
        this.curr_equipe = this.$route.params.equipe ?? this.curr_equipe
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        fetchData() {
            this.error = null
            this.loading = true
            var vm = this
            var fetchurl = this.$api_url_emobiles + '&sort[title]=1&filter[active]=true&populate=1'
            axios({
                    method: 'get',
                    url: fetchurl
                }).then(function(response) {
                    vm.loading = false
                    if (response.data.entries.length > 0) {
                        vm.equipes = response.data.entries
                        vm.error = null
                    } else {
                        vm.equipes = null
                        vm.error = 'page introuvable'
                        vm.$router.push({ name: '404' })

                    }
                })
                .catch(function() {
                    vm.error = 'page introuvable'
                    vm.$router.push({ name: '404' })
                })
        },

        searchEM2: function() {
            var qsearch = this.searchQuery ? this.searchQuery.trim() : ''
            if (qsearch.length < this.searchMinChars) {
                this.$buefy.toast.open({
                    message: 'Veuillez indiquer au moins ' + this.searchMinChars + ' caractères pour lancer la recherche',
                    type: 'is-warning',
                    duration: 3500
                })
                return
            }

            this.searchInit = true
            this.searchResult = false
            this.searchResultEquipes = []

            var query = normalizeText(qsearch)
            if (!query) {
                this.$buefy.toast.open({
                    message: 'Veuillez indiquer une recherche valide',
                    type: 'is-warning',
                    duration: 3500
                })
                return
            }

            var matches = []
            for (var i = 0; i < this.equipes.length; i++) {
                var rawSecteur = flattenSecteur(this.equipes[i].secteur)
                var tokens = splitTokens(rawSecteur)
                var bestScore = 0
                var bestType = null
                var matchedTerms = []

                for (var j = 0; j < tokens.length; j++) {
                    var token = tokens[j]
                    var info = computeMatchInfoFromMultiWordToken(query, token.norm, this.fuzzyMaxDistanceShort, this.fuzzyMaxDistanceLong)
                    if (info.score > 0) {
                        var termEntry = { raw: token.raw, type: info.type || 'exact' }
                        var existing = matchedTerms.find(function(item) {
                            return item.raw === termEntry.raw
                        })
                        if (!existing) {
                            matchedTerms.push(termEntry)
                        } else if (existing.type !== 'exact' && termEntry.type === 'exact') {
                            existing.type = 'exact'
                        }
                        if (info.score > bestScore) {
                            bestScore = info.score
                            bestType = info.type || 'exact'
                        }
                    }
                }

                if (bestScore > 0) {
                    matches.push({
                        equipe: this.equipes[i],
                        score: bestScore,
                        type: bestType,
                        matchedTerms: matchedTerms
                    })
                }
            }

            matches.sort(function(a, b) {
                // D'abord trier par type: 'exact' avant 'fuzzy'
                if (a.type !== b.type) {
                    if (a.type === 'exact') return -1
                    if (b.type === 'exact') return 1
                }
                // Ensuite trier par score décroissant
                return b.score - a.score
            })
            this.searchResultEquipes = matches

            this.searchResult = this.searchResultEquipes.length > 0
            this.searchResultMult = this.searchResultEquipes.length > 1
        }

    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bloc_equipe {
    border-left: 3px dotted silver;
    padding-left: 1rem;
}
.search-match-list {
    margin-top: 0.5rem;
}
.search-match-label {
    font-weight: 600;
    margin-right: 0.5rem;
}
.search-match {
    display: inline-block;
    margin-right: 0.35rem;
    margin-bottom: 0.35rem;
    padding: 0.2rem 0.5rem;
    border-radius: 0.4rem;
    color: #333;
    font-size: 0.85rem;
}
.search-match.exact {
    background-color: #c8f7d1;
    border: 1px solid #7ac77e;
}
.search-match.fuzzy {
    background-color: #fff6a3;
    border: 1px solid #d2b24b;
}
</style>
<style scoped>
.page {
    min-height: 300px;
    margin-bottom: 100px;
    margin-top: 100px;
}

.box {
    border-radius: 0px;
    border-left: 12px solid #ff3860;
    box-shadow: 1px 1px 12px #555;
}

li.is-activew {
    font-weight: bold;
}

li a {
    font-size: 14pt;

}

li.is-active a {
    border-bottom-color: #ff3860 !important;
    color: white !important;
    background: #ff3860;
}

iframe {
    height: 500px;
}

.content figure {
    margin-left: 0em;
    margin-right: 0em;
}


@media only screen and (max-width: 600px) {
    .page {
        margin-bottom: 50px;
        margin-top: 50px;
    }
}
</style>